<template>
  <div class="comment-details">
    <div class="list" v-for="(value, index) in data" :key="index">
      <p class="content">{{value.user_nickname}} 回复 {{value.to_user_nickname}}: {{value.content}}</p>
      <a-row type="flex" class="btns">
        <a-col flex="1">{{value.created_at}}</a-col>
        <a-col>
          <a-space>
            <a-popover title="评论" v-model="value.note.show" trigger="click">
              <template slot="content">
                <a-textarea v-model="value.note.value" placeholder="请输入评论"></a-textarea>
                <a-space>
                  <a-button type="link" @click="replyComment(value)">提交</a-button>
                </a-space>
              </template>
              <p>评论</p>
            </a-popover>
            <p v-if="value.is_hide" @click="enableComment(value)">显示</p>
            <p v-else @click="disableComment(value)">隐藏</p>
          </a-space>
        </a-col>
      </a-row>
      <template v-if="value.dialog && value.dialog.data.length">
        <a-spin tip="加载中..." :spinning="value.loading">
          <comment-details :init-data="value.dialog.data" :init-page="initPage" :community-id="communityId"></comment-details>
        </a-spin>
        <a-pagination v-model="value.dialog.meta.pagination.current_page" :page-size="value.dialog.meta.pagination.per_page" :total="value.dialog.meta.pagination.total" @change="handleChangePagination(value, ...arguments)"></a-pagination>
      </template>
    </div>
  </div>
</template>

<script>
  import CommentService from '@/io/comment.js';

  export default {
    name: 'CommentDetails',
    props: {
      communityId: {
        type: Number,
        default: null
      },
      initPage: {
        type: Function,
        default: null
      },
      initData: {
        type: Array,
        default: null
      },
    },
    watch: {
      initData: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.data = this.$createNewVariable(newValue.map(val => {
              val.note = {
                value: null,
                show: false
              }
              val.loading = false;
              if (val.dialog) {
                val.dialog.data.forEach(m => {
                  m.parentId = val.id;
                });
              }
              return val;
            }));
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        loading: false,
        data: []
      }
    },
    methods: {
      handleChangePagination(data, page, perPage) {
        data.loading = true;
        CommentService.replyListPage(data.id, page, perPage).then(res => {
          data.dialog = res;
        }).catch(err => {}).finally(() => {
          data.loading = false;
        });
      },
      enableComment(data) {
        CommentService.enable(data.id).then(res => {
          this.initPage();
        }).catch(err => {});
      },
      disableComment(data) {
        CommentService.disable(data.id).then(res => {
          this.initPage();
        }).catch(err => {});
      },
      replyComment(data) {
        if (data.note.value) {
          CommentService.reply(this.communityId, data.parentId || data.id, data.note.value, data.id).then(res => {
            this.initPage();
          }).catch(err => {}).finally(() => {
            data.note.value = null;
            data.note.show = false;
          });
        } else {
          this.$message.error('请输入评论');
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .comment-details {
    .list {
      padding: @padding-lg;
      box-shadow: @box-shadow-base;
      &:not(:last-of-type) {
        margin-bottom: @padding-lg;
      }
      .content {
        font-size: @font-size-lg;
        margin-bottom: @padding-sm;
      }
      & > div:not(:last-of-type) {
        margin-bottom: @padding-sm;
      }
    }
    .btns {
      .ant-space {
        .ant-space-item {
          cursor: pointer;
          &:hover {
            color: @primary-color;
          }
        }
      }
    }
    .ant-pagination {
      margin-top: @padding-lg;
      text-align: right;
    }
  }
</style>